import { render, staticRenderFns } from "./DimensionsTopMenu.vue?vue&type=template&id=5e085f79"
import script from "./DimensionsTopMenu.vue?vue&type=script&lang=js"
export * from "./DimensionsTopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports